/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderTrainingReviews = () => {
	const el = {
		parent: '.mi-training-reviews-wrapper',
	};

	if (!$(el.parent).length) return;

	const initSwiperForElement = function ($element) {
		var $swiperContainer = $element.find('.mi-training-reviews-slider');
		if (!$swiperContainer.length) return;

		var params = {
			slidesPerView: 1,
			spaceBetween: 20,
			loop: false,
			pagination: {
				el: $element.find('.mi-training-reviews-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $element.find('.mi-training-reviews-next')[0],
				prevEl: $element.find('.mi-training-reviews-prev')[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		};

		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.utils && elementorFrontend.utils.swiper) {
			const asyncSwiper = elementorFrontend.utils.swiper;
			new asyncSwiper($swiperContainer, params).then(function (newSwiperInstance) {
				$swiperContainer.data('swiper', newSwiperInstance);
			});
		} else if (typeof Swiper !== 'undefined') {
			var newSwiper = new Swiper($swiperContainer[0], params);
			$swiperContainer.data('swiper', newSwiper);
		}
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/training-reviews.default',
				function ($element) {
					initSwiperForElement($element);
				}
			);
		}
	});

	// Immediate initialization for non-Elementor or pre-initialized frontend pages
	$(el.parent).each(function () {
		initSwiperForElement($(this));
	});
};

try {
	sliderTrainingReviews();
} catch (error) {
	console.warn(error);
}
